const fetch = require('~~/common/js/universal/fetch');
const { getSearchFeedbackProxiedURL } = require('~~/search/common/js/universal/proxy/search-feedback');

const visibilityFeedback = async (ids = [], visibilityFeedbackUrl) => {
  const url = new URL(visibilityFeedbackUrl);
  url.searchParams.set('tids', ids.join());

  const response = await fetch(url.toString());
  if (response.status >= 400) {
    // if an error response comes back, we should log it
    // and observe the number of error responses
    // TODO: increment a Prometheus counter here
    const error = await response.text();
    throw new Error(`Visibility feedback: received error response - ${error}`);
  }
};

module.exports = async ({ ids = [], adTracking, proxyUrl, shouldProxy = false }) => {
  // if visibilityFeedbackUrl is not present, the proxied url
  // will also not be set and we can return early
  if (ids.length === 0 || !adTracking?.visibilityFeedbackUrl) {
    return null;
  }

  if (shouldProxy) {
    // if the try with proxied url fails for any reason, we try again with the normal url,
    // also returning the catch for thrown errors to bubble up to be logged by sentry.
    const originalUrl = adTracking?.visibilityFeedbackUrl;
    const proxiedURL = getSearchFeedbackProxiedURL(originalUrl, proxyUrl);
    return visibilityFeedback(ids, proxiedURL)
      .catch(async () => visibilityFeedback(ids, adTracking?.visibilityFeedbackUrl));
  }

  return visibilityFeedback(ids, adTracking?.visibilityFeedbackUrl);
};

module.exports.VISIBILITY_FEEDBACK_THRESHOLD = 4;
